import logger from 'services/logger';
import { ShareMethodName } from './ShareMethod/types';

// Partially copied from https://github.com/Yleisradio/arkki/blob/6e4b5e9638ab34171df4625bf17340a6e62bcf6f/packages/arkki-web/src/utils/share-utils.ts
export function getURLWithUTMParameters(
  url: string,
  shareMethod: ShareMethodName
): string {
  try {
    const urlObject = new URL(url);
    const { searchParams } = urlObject;
    searchParams.set('utm_medium', 'social');
    searchParams.set('utm_campaign', 'areena-web-share');
    searchParams.set('utm_source', `${shareMethod}-share`);
    return urlObject.toString();
  } catch (e) {
    logger.error(e, 'Error while attaching UTM parameters to share URL');
    return url || '';
  }
}

export function openWindow(url: string): void {
  window.open(url, 'areena-share', 'width=550,height=550,noopener');
}
